import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_na-mapi" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_x" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MapCustom = _resolveComponent("MapCustom")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("span", {
      class: "openMap buttonMap",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openMap && _ctx.openMap(...args)))
    }, _hoisted_2),
    _createVNode(_component_Dialog, {
      visible: _ctx.showMap,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showMap) = $event)),
      class: "fullScreenMap"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_MapCustom, {
            markers: _ctx.markers,
            center: _ctx.center,
            onCenterChanged: _ctx.updateCenter,
            onZoomChanged: _ctx.updateZoom,
            onClose: _ctx.closeMap
          }, null, 8, ["markers", "center", "onCenterChanged", "onZoomChanged", "onClose"]),
          _createElementVNode("span", {
            class: "openMap buttonMap",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeMap && _ctx.closeMap(...args)))
          }, _hoisted_4)
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}